import { useState } from "preact/hooks";
import type { DashboardViewModel } from "../app/dashboardViewModel";

/**
 * First run on an empty phone: three short cards — what the app does, pick or add your grinder, add your first bean.
 * Adding the bean (or Skip) ends it; the recommendation card then suggests a three-shot calibration sweep.
 */
export function FirstRun(props: { vm: DashboardViewModel; onPickGrinder: () => void; onAddGrinder: () => void; onAddBean: () => void }) {
  const { vm } = props;
  const [step, setStep] = useState(0);
  const g = vm.selectedGrinder.value;
  const dots = (
    <div class="dots" aria-hidden="true">{[0, 1, 2].map((i) => <span key={i} class={i === step ? "on" : ""} />)}</div>
  );

  return (
    <section class="card first-run" aria-label="Welcome">
      {dots}
      {step === 0 && (
        <>
          <h2>Dial in faster</h2>
          <p>Log each shot's time and grind. Puck Tech predicts the setting for your next shot, and gets better at your grinder and beans the more you log.</p>
          <p class="hint">Everything stays on this phone.</p>
          <div class="actions-inline">
            <button class="ghost" type="button" onClick={() => void vm.finishFirstRun()}>Skip</button>
            <button type="button" onClick={() => setStep(1)}>Next</button>
          </div>
        </>
      )}
      {step === 1 && (
        <>
          <h2>Your grinder</h2>
          <p>{g ? <>Using <strong>{g.name}</strong>.</> : "Pick the grinder you use."} Change it, or add yours if it isn't listed.</p>
          <div class="sheet">
            <button class="secondary block" type="button" onClick={props.onPickGrinder}>Choose grinder</button>
            <button class="secondary block" type="button" onClick={props.onAddGrinder}>Add grinder</button>
          </div>
          <div class="actions-inline">
            <button class="ghost" type="button" onClick={() => setStep(0)}>Back</button>
            <button type="button" onClick={() => setStep(2)}>Next</button>
          </div>
        </>
      )}
      {step === 2 && (
        <>
          <h2>Your first bean</h2>
          <p>Add the coffee you're pulling: its roast date matters most. Then pull three shots across the dial so the app can learn your grinder.</p>
          <button class="primary" type="button" onClick={props.onAddBean}>Add bean</button>
          <div class="actions-inline">
            <button class="ghost" type="button" onClick={() => setStep(1)}>Back</button>
            <button class="ghost" type="button" onClick={() => void vm.finishFirstRun()}>Skip</button>
          </div>
        </>
      )}
    </section>
  );
}
